export default __webpack_public_path__ + "a3f06963df4ea929177cbfe44557776c.svg";